import { useState } from "react";
import { Menu, Button } from "antd";
import { HomeOutlined, LeftOutlined } from "@ant-design/icons";
import { Layout } from "antd";
// remove this import and delete file if updated is successful
// import SideNavDynamicItems from "../../containers/SideNavDynamicItems";
import SideNavDynamicItems from "../../containers/SideNavDynamicItems";
import { Divider } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { toggleCollapsed } from "../../redux/store/siderSlice";
import { useNavigate } from "react-router-dom";

/**
 * @note we use the refactored version of the SideNavDynamicItems that has cleaner code.
 * Menu items are disable by default unless in allowedTabs.
 * 
 * Test for bugs where an account has a mix of enable and disabled tabs.
 */

const SideNav = () => {
  const collapsed = useSelector((state) => state.sider.collapsed);
  const dispatch = useDispatch();
  // remove this line if updated is successful
  // const { menuItems } = SideNavDynamicItems();
  const { menuItems: menuItemsRefactored } = SideNavDynamicItems();
  const isAuthenticated = useSelector((state) => state.oauth.isAuthenticated);
  const currentUrlPath = window.location.pathname;
  const navigate = useNavigate();

  //OpenKeys state to control which submenus are open
  const [openKeys, setOpenKeys] = useState([
    "/performance",
    "/performance/marketing-reporting",
    "/performance/marketing-reporting/submenu",
    "/influencer",
    "growth-dashboards", // Add this
    "paid-media-dashboards", // Add this
  ]);

  const getSelectedKeys = () => {
    const keys = [currentUrlPath];

    // Special handling for marketing reporting overview
    if (currentUrlPath === "/performance/marketing-reporting") {
      return [currentUrlPath];
    }

    // For other marketing reporting routes (Google, Facebook, etc.)
    if (currentUrlPath.includes("/performance/marketing-reporting/")) {
      // Don't include the parent key for sub-items
      return [currentUrlPath];
    }

    return keys;
  };

  const homeMenuItem = [
    {
      key: "/Home",
      label: !collapsed && <span style={{ marginLeft: "2px" }}>Home</span>,
      icon: <HomeOutlined />,
      onClick: () => navigate("/"),
      title: null,
    },
  ];

  if (!isAuthenticated || currentUrlPath === "/") {
    return null;
  }

  return (
    <Layout.Sider
      width={280}
      collapsedWidth={100}
      collapsed={collapsed}
      overflow="hidden"
      style={{
        backgroundColor: "var(--primary-color)",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        padding: "0px 12px",
      }}
    >
      <Layout
        style={{
          backgroundColor: "var(--primary-color)",
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: !collapsed ? "space-between" : "center",
            padding: "32px",
            minHeight: "138px",
          }}
        >
          {!collapsed && (
            <img
              src="/co_monogram_neon_green.svg"
              alt="Charlie Oscar"
              style={{ width: "40px", height: "auto" }}
            />
          )}
          <Button
            type="primary"
            icon={
              <LeftOutlined
                rotate={collapsed ? 180 : 0}
                style={{ transition: "all 0.2s" }}
              />
            }
            onClick={() => dispatch(toggleCollapsed())}
            style={{
              backgroundColor: "var(--secondary-color)",
              color: "var(--very-dark-green-color)",
              boxShadow: "none",
              borderRadius: "40%",
              height: "24px",
              width: "24px",
              padding: "4px",
            }}
          />
        </div>

        <Menu
          openKeys={openKeys}
          onOpenChange={setOpenKeys}
          selectedKeys={getSelectedKeys()}
          mode="inline"
          style={{
            backgroundColor: "var(--primary-color)",
            borderWidth: "0px",
            maxHeight: "100%", // or whatever height fits your layout
            overflowY: "auto",
            scrollbarWidth: "none", // For Firefox
          }}
          items={menuItemsRefactored}
        />
        <div
          style={{
            marginTop: "auto",
            marginBottom: "35px",
            paddingTop: "0px",
          }}
        >
          <div style={{ padding: "0px 12px", marginTop: "0px" }}>
            <Divider
              style={{
                borderColor: "var(--very-dark-green-color)",
                marginTop: "0px",
              }}
            />
          </div>

          <Menu
            defaultOpenKeys={["/Home"]}
            style={{
              borderRight: "0px", // remove right default border
            }}
            items={homeMenuItem}
          />
        </div>
      </Layout>
    </Layout.Sider>
  );
};

export default SideNav;
